import React, { useEffect } from 'react';
import { CircularProgress } from '@medely/web-components';

export interface LocationRedirectProps {
  host: string;
  location: {
    pathname: string;
    search: string;
  };
}

const LocationRedirect = ({ host, location }: LocationRedirectProps): React.ReactElement => {
  useEffect(() => {
    const redirect = `${host}${location.pathname}${location.search}`;
    window.location.href = redirect;
  }, []);
  return <CircularProgress />;
};

export default LocationRedirect;
